export default __webpack_public_path__ + "static/ocean-417f663d9138b0624dce80e60d985a38.webm";